import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

import { onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const baseSize = 16;
const setRem = () => {
  // 当前页面宽度相对于 1920 宽的缩放比例，可根据自己需要修改。
  const scale = document.documentElement.clientWidth / 1920;
  // 设置页面根节点字体大小, 字体大小最小为12
  const size = baseSize * Math.min(scale, 2);
  const fontSize = size > 12 ? size : 12;
  document.documentElement.style.fontSize = fontSize + "px";
};
// const debounce = (fn, delay) => {
//   let timer = null;
//   return function () {
//     let context = this;
//     let args = arguments;
//     clearTimeout(timer);
//     timer = setTimeout(function () {
//       fn.apply(context, args);
//     }, delay);
//   };
// };

// const _ResizeObserver = window.ResizeObserver;
// window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
//   constructor(callback) {
//     callback = debounce(callback, 16);
//     super(callback);
//   }
// };
setRem();
window.onresize = () => {
  setRem();
  // bodyScale();
};
// const bodyScale = () => {
//   var devicewidth = document.documentElement.clientWidth; //获取当前分辨率下的可是区域宽度
//   var scale = devicewidth / 1920; // 分母——设计稿的尺寸
//   document.body.style.cssText = "zoom:" + scale + ""; //放大缩小相应倍数
// };
onMounted(() => {
  // new DevicePixelRatio().init();
  // bodyScale();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view)
  ]))
}
}

})